import { getField, updateField } from 'vuex-map-fields'
import Line from './line'
import api from '../api/api'

export const namespaced = true

let baseUrl = '/head_reference_lines/'

const line = new Line(baseUrl)

const getDefaultState = () => {
  return {
    ...structuredClone(line.state),
    color: 'navy',
    dash: 'solid',
    name: 'Head Reference Line',
    storeNamespace: 'headReferenceLine'
  }
}

export const state = getDefaultState()

export const mutations = {
  ...line.mutations,
  updateField
}

export const actions = {
  ...line.actions,
  async generate(context) {
    context.commit('TOGGLE_GENERATE_LOADING')
    const id = context.rootGetters['stabSchematisationStage/currentStabSchematisationStageId']
    const multipleHeadLineNumber =
      context.rootGetters['multipleHeadLine/getCurrentMultipleHeadLineNumber']
    const multipleHeadLineIntrusionLength =
      context.rootGetters['multipleHeadLine/getCurrentMultipleHeadLineIntrusionLength']
    const currentMultipleHeadLine = context.rootState.multipleHeadLine.currentItem
    const url = baseUrl + id + '/generate/'
    try {
      const response = await api.post(url, {
        number: multipleHeadLineNumber,
        intrusion_length: multipleHeadLineIntrusionLength,
        properties: { multiple_head_line: currentMultipleHeadLine.id }
      })
      await context.dispatch('replaceLine', response)
    } catch (e) {
      console.log(e)
    }
    context.commit('TOGGLE_GENERATE_LOADING')
  },
  updateOverviewHeadline2({ commit, state }, { id, enabled }) {
    const headline2 = state.itemsOverview.find((item) => item.id === id)
    if (headline2) {
      commit('SET_NESTED_PARAMETER', {
        item: headline2,
        parameter: 'properties.enabled',
        value: enabled
      })
    }
  }
}

export const getters = {
  ...line.getters,
  getField
}
